import { Link } from "react-router-dom";

const footerLinks = {
  分类导航: [
    { label: "实用工具", href: "/category/tools" },
    { label: "设计素材", href: "/category/design" },
    { label: "技术文章", href: "/category/tech" },
    { label: "学习资源", href: "/category/learning" },
    { label: "效率提升", href: "/category/productivity" },
    { label: "精品推荐", href: "/category/recommended" },
  ],
  关于我们: [
    { label: "品牌介绍", href: "/about" },
    { label: "用户口碑", href: "/about#reputation" },
    { label: "联系我们", href: "/about#contact" },
  ],
  精选推荐: [
    { label: "效率工具推荐", href: "/article/article-1" },
    { label: "免费素材网站", href: "/article/article-2" },
    { label: "年度必读书单", href: "/article/article-4" },
    { label: "AI创作工具", href: "/article/article-6" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="text-xl font-bold text-foreground-900 whitespace-nowrap">
                91精选
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专注优质内容发现与聚合的精品平台，汇集海量精选资源，帮助您快速找到最值得收藏的好内容。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 91精选 版权所有 | 精品内容聚合平台
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">服务条款</a>
            <a href="#" className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap" rel="nofollow">RSS订阅</a>
          </div>
        </div>
      </div>
    </footer>
  );
}